import {TypeContentEnum} from "../../Variables/TypeContentEnum.js";
import {TypeProcessEnum} from "../../Variables/TypeProcessEnum.js";
import {JsonFetchJson} from "../../Helper/FetchHelper.js";
import {OnTemplateAdd, OnTemplateUpdate} from "../../Delegates/TemplateDelegate.js";
import {ITemplateModel} from "../../Model/Template/ITemplateModel.js";
import {ResponseApi} from "../../Model/ResponseApi.js";
import {String} from "../../Tools/Misc.js"
import {NotificationHelper} from "../../Helper/NotificationHelper";

    export  class TemplateUpsert {
        /**
         * @param payload Template à enregistrer (pivot ou traduction).
         * @param silent  Quand vrai, ne déclenche pas OnTemplateAdd/Update : à
         *                utiliser pour les traductions, qui ne sont pas des
         *                lignes de la liste (seuls les pivots y figurent).
         * @returns Le modèle enregistré (avec sa Primarykey générée), ou null en cas d'erreur.
         */
        public static Put = async (payload : ITemplateModel, silent: boolean = false) => {
            return JsonFetchJson.Put<ResponseApi<ITemplateModel>>("/template", payload)
                .then((response) => {

                    if (response.Errors.length > 0) {
                        response.Errors.forEach(x => NotificationHelper.Instance.error(x.Message));
                        return null;
                    }

                    response.Data.TypeProcessLibelle =
                        TypeProcessEnum.Instance.GetLibelle(response.Data.TypeProcess);

                    response.Data.TypeContentLibelle =
                        TypeContentEnum.Instance.GetLibelle(response.Data.TypeContent);

                    if (!silent) {
                        if (payload.Primarykey == String.GetEmptyGuid) {
                            OnTemplateAdd.Fire(response.Data);
                        } else  {
                            OnTemplateUpdate.Fire(response.Data);
                        }
                    }

                    return response.Data;
                })
        }
    }
